import { ISupportCategoryItem } from "interfaces";
import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { formatNumber, isHaveActionPermission } from "utills/helpers";
import { formattedFilterParamsString } from "providerrs";

interface SupportCategoryCardProps {
  data?: ISupportCategoryItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const SupportCategoryCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: SupportCategoryCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: ISupportCategoryItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <SwitchButton
              checked={item.is_active}
              disabled={!isHaveActionPermission("support_categories", "cs", "edit")}
              onChange={() => _toggleActive(item.id, item.is_active)}
            />

            <div className="flex items-center gap-x-[8px]">
              <Link to={`/cs/support-category/${item.id}`} className="w-fit">
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission("support_categories", "cs", "edit") ? (
                <Link
                  to={`/cs/support-category/${item.id}/edit`}
                  className="w-fit"
                >
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Categories name vie</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.name_vi}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Categories name eng
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.name_en}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Position</p>
            <p className="flex-1 text-right text-sm leading-6">
              {formatNumber(item.order_number)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Number of Q&A</p>
            <Link 
              to={`/cs/support-qa?${formattedFilterParamsString([
                {field: "category_id", operator: "eq", value: item.id}
              ])}`}
              className="text-brand-500 flex-1 text-right text-sm leading-6 hover:underline"
            >
              {formatNumber(item.number_of_qa)}
            </Link>
          </li>
        </div>
      ))}
    </ul>
  );
};
